import {
  DrawerDescription,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerClose,
  DrawerTitle,
  Button,
  Drawer,
} from '@ui/components';
import { Cancel } from '@ui/components/icons';
import { t } from 'i18next';

import { InvoiceRecipientsTable } from '../invoice-recipients-table';

interface InvoiceRecipientsDrawerProps {
  invoiceName: string;
  invoiceId: string;
  open: boolean;
  onClose: () => void;
}

export const InvoiceRecipientsDrawer = (props: InvoiceRecipientsDrawerProps) => {
  const { invoiceName, invoiceId, open, onClose } = props;

  return (
    <Drawer onClose={onClose} open={open} handleOnly>
      <DrawerContent>
        <DrawerHeader className="flex flex-row items-center justify-between p-4 border-b border-border-weak">
          <DrawerTitle>{invoiceName}</DrawerTitle>
          <DrawerDescription />
          <DrawerClose asChild>
            <Button variant="ghost" size="small" icon>
              <Cancel />
            </Button>
          </DrawerClose>
        </DrawerHeader>

        <div className="p-4 overflow-hidden">
          {open && <InvoiceRecipientsTable invoiceId={invoiceId} />}
        </div>

        <DrawerFooter>
          <DrawerClose asChild>
            <Button size="large" wide>
              {t('FILES_REPORTS.INVOICING.DRAWER.CLOSE')}
            </Button>
          </DrawerClose>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};
